import { __awaiter, __generator } from "tslib";
import * as React from 'react';
import { AppCard } from './app-card';
import { Card } from 'wix-style-react';
import { composer } from '../../component-decorators/composer';
import { getTagsDataBySlugs } from '../../api';
var isLastAppCard = function (apps, i) {
    return apps.length - 1 === i;
};
export var AppsSection = composer()
    .withExperiments()
    .compose(function (_a) {
    var apps = _a.apps, mainButtonAction = _a.mainButtonAction, children = _a.children, msid = _a.msid, origin = _a.origin, addAppAgain = _a.addAppAgain, getAppInstance = _a.getAppInstance, updateEmbeddedScriptAppsStatus = _a.updateEmbeddedScriptAppsStatus, embeddedScriptAppsStatus = _a.embeddedScriptAppsStatus, openModal = _a.openModal, baseUrl = _a.baseUrl, deleteApp = _a.deleteApp, isBusinessApp = _a.isBusinessApp, editorType = _a.editorType, gotoWebSolutionPage = _a.gotoWebSolutionPage, siteIsPremium = _a.siteIsPremium, isActionRequiredSection = _a.isActionRequiredSection, openApp = _a.openApp, deleteAppFromBundle = _a.deleteAppFromBundle, dataHook = _a.dataHook, locale = _a.locale, showHolidaySale = _a.showHolidaySale, siteIsBusinessFirstSite = _a.siteIsBusinessFirstSite;
    var SectionHeader = React.Children.toArray(children)[0];
    var _b = React.useState([]), appsSale = _b[0], setAppsSale = _b[1];
    var loadSolutionsBySlug = function (
    // tslint:disable-next-line:no-shadowed-variable
    locale, 
    // tslint:disable-next-line:no-shadowed-variable
    countryCode) {
        if (locale === void 0) { locale = 'en'; }
        if (countryCode === void 0) { countryCode = 'us'; }
        return __awaiter(void 0, void 0, void 0, function () {
            var tagsData;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!showHolidaySale) return [3 /*break*/, 2];
                        return [4 /*yield*/, getTagsDataBySlugs(baseUrl, ['pre-holiday-sale'], locale, countryCode, true)];
                    case 1:
                        tagsData = _b.sent();
                        setAppsSale((_a = tagsData === null || tagsData === void 0 ? void 0 : tagsData.webSolutions) === null || _a === void 0 ? void 0 : _a.map(function (solution) { return solution === null || solution === void 0 ? void 0 : solution.baseInfo.id; }));
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    React.useEffect(function () {
        void loadSolutionsBySlug('en', 'us');
    }, []);
    return (React.createElement("div", null, apps.length ? (React.createElement("div", { style: { marginBottom: '24px' } },
        React.createElement(Card, { dataHook: dataHook },
            React.cloneElement(SectionHeader),
            React.createElement(Card.Divider, null),
            apps.map(function (app, i) { return (React.createElement("div", { key: app.webSolutionBase.id, onClick: function () { return mainButtonAction(app); } },
                React.createElement(AppCard, { app: app, msid: msid, origin: origin, baseUrl: baseUrl, editorType: editorType, addAppAgain: addAppAgain, getAppInstance: getAppInstance, embeddedScriptAppsStatus: embeddedScriptAppsStatus, updateEmbeddedScriptAppsStatus: updateEmbeddedScriptAppsStatus, deleteApp: deleteApp, mainButtonAction: mainButtonAction, openModal: openModal, isBusinessApp: isBusinessApp, index: i, gotoWebSolutionPage: gotoWebSolutionPage, siteIsPremium: siteIsPremium, isActionRequiredApp: isActionRequiredSection, openApp: openApp, deleteAppFromBundle: deleteAppFromBundle, showHolidaySale: showHolidaySale, isAppPartOfSale: appsSale.includes(app.webSolutionBase.id), locale: locale, siteIsBusinessFirstSite: siteIsBusinessFirstSite }),
                !isLastAppCard(apps, i) && React.createElement(Card.Divider, null))); })))) : null));
});
//# sourceMappingURL=apps-section.js.map